import React from "react";

const TONE = {
  match: { border: "#00B67A" },
  warning: { border: "#F59E0B" },
  error: { border: "#EF4444" },
  info: { border: "#3B82F6" },
  neutral: { border: "#0F2044" },
};

export const KPICard = ({ label, value, sub, tone = "neutral", testId, mono = true }) => {
  const t = TONE[tone] || TONE.neutral;
  return (
    <div
      data-testid={testId}
      className="bg-white rounded-md p-6 shadow-sm flex flex-col"
      style={{
        border: "1px solid var(--color-border)",
        borderLeftWidth: 4,
        borderLeftColor: t.border,
      }}
    >
      <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-2">
        {label}
      </div>
      <div className={`text-3xl font-bold text-[#0F2044] ${mono ? "font-mono" : ""}`} style={{ fontVariantNumeric: "tabular-nums" }}>
        {value}
      </div>
      {sub && <div className="text-sm text-gray-500 mt-2">{sub}</div>}
    </div>
  );
};

export default KPICard;
